import React from 'react'
import {Navigate} from 'react-router-dom'
import {useAuth} from '@contexts/authContext'
import styles from '@styles/components/Route.module.css'
import Loading from '@components/General/Loading'

export const ProtectedAuthRoute = ({children}) => {
    const {user, validationStatus, loading} = useAuth()

    if (loading) {
      return (
        <div className={styles.container}>
          <Loading loaderHeight="120px" loaderWidth="120px" />
        </div>
      )
    }
    
    if (!user) return <Navigate to='/login' />
    if (validationStatus !== 'Validated') return <Navigate to='/unauthorized'/>
    
    return <>{children}</>
}
